import { baseRoutes } from './routes'

import { CampaignsIcon } from 'shared'
import { ProfileIcon, ResourcesIcon } from 'assets/icons'

const links = [
  {
    name: 'Profile',
    url: baseRoutes.profile,
    Icon: ProfileIcon,
  },
  {
    name: 'Campaigns',
    url: baseRoutes.campaigns,
    Icon: CampaignsIcon,
  },
  {
    name: 'Resources',
    Icon: ResourcesIcon,
    url: baseRoutes.resources,
  },
]

export default links
